import { Grid, Typography } from "@mui/material"
import styles from "../../../../Styles/ComponentStyles/ProfileStyle/AccValueTab.module.scss"
import CustomNumberTextField from "../../../../GlobalComponent/CustomNumberTextField/CustomNumberTextField"
import { useContext, useEffect, useState } from "react"
import { ProfileContext, ProfileContextPayload } from "../../../../Context/ProfileDetailsContext"
import IULFeesChart from "./IULFeesChart"

const FeesTab = () => {
    const {
        finalData,
        iulFeesbtnToggled,
    } = useContext(ProfileContext) as ProfileContextPayload

    const [feesTpAgeMin, setFeesTpAgeMin] = useState<number | null>(null);
    const [feesTpAgeMax, setFeesTpAgeMax] = useState<number | null>(null);
    const [feesIulAgeMin, setFeesIulAgeMin] = useState<number | null>(null);
    const [feesIulAgeMax, setFeesIulAgeMax] = useState<number | null>(null);

    const [changeYearTypical, setChangeYearTypical] = useState(finalData?.ageAtRetirement)
    const [changeYearIUL, setChangeYearIUL] = useState(finalData?.ageAtRetirement)

    const [feesTypicalAgeArray, setFeesTypicalAgeArray] = useState<number[]>([]);
    const [flagShowCalculationErrorTp, setFlagShowCalculationErrorTp] = useState(false);

    useEffect(() => {
        if (finalData?.typical_plan?.FEES_age_data && finalData?.iul_plan?.FEES_age_data) {
            const taxTypicalAge = Object.keys(finalData.typical_plan.FEES_age_data).map(Number);
            const taxIul_planAge = Object.keys(finalData?.iul_plan?.FEES_age_data).map(Number);

            setFeesTypicalAgeArray(taxTypicalAge)

            setFeesTpAgeMin(taxTypicalAge[0]);
            setFeesTpAgeMax(taxTypicalAge[taxTypicalAge.length - 1]);
            setFeesIulAgeMin(taxIul_planAge[0]);
            setFeesIulAgeMax(taxIul_planAge[taxIul_planAge.length - 1]);
            setChangeYearTypical(taxTypicalAge[0]);
            setChangeYearIUL(taxIul_planAge[0]);
        }
    }, [finalData]);

    useEffect(() => {
        if (changeYearTypical == Number(feesTypicalAgeArray[feesTypicalAgeArray?.length - 1])) {
            setFlagShowCalculationErrorTp(true)
        } else {
            setFlagShowCalculationErrorTp(false)
        }
    }, [changeYearTypical])

    const formatNumber = (q: any) => {
        if (q || q == 0) {
            return q.toLocaleString('en-US', {
                style: 'currency',
                minimumFractionDigits: 0,
                maximumFractionDigits: 0,
                currency: "usd"
            })
        }
    }

    const InputChangeYearIUL = (e: any) => {
        let val = parseInt(e.target.value);
        if (val >= Number(feesIulAgeMin) && val <= Number(feesIulAgeMax)) {
            setChangeYearIUL(val)
        }
        else {

            if (val >= Number(feesIulAgeMax))
                setChangeYearIUL(Number(feesIulAgeMax))
            else {
                setChangeYearIUL(Number(feesIulAgeMin))
            }
            return;
        }
    }

    const InputBlurChangeIUL = (e: any) => {
        let val = parseInt(e.target.value);
        let checkInBeetween = isInputBetween(Number(feesIulAgeMin), Number(feesIulAgeMax), val)
        if (checkInBeetween == false) {
            if (val >= Number(feesIulAgeMax))
                setChangeYearIUL(Number(feesIulAgeMax))
            else {
                setChangeYearIUL(Number(feesIulAgeMin))
            }
            return
        }
    }

    const inputChangeYear = (e: any) => {
        let val = parseInt(e.target.value);
        if (val >= Number(feesTpAgeMin) && val <= Number(feesTpAgeMax)) {
            setChangeYearTypical(val)
        }
        else {

            if (val >= Number(feesTpAgeMax))
                setChangeYearTypical(Number(feesTpAgeMax))
            else {
                setChangeYearTypical(Number(feesTpAgeMin))
            }
            return;
        }
    }

    const isInputBetween = (num1: any, num2: any, value: any) => value > num1 && value < num2;

    const inputBlureChangeYear = (e: any) => {
        let val = parseInt(e.target.value);
        let checkInBeetween = isInputBetween(Number(feesTpAgeMin), Number(feesTpAgeMax), val)
        if (checkInBeetween == false) {
            if (val >= Number(feesTpAgeMax))
                setChangeYearTypical(Number(feesTpAgeMax))
            else {
                setChangeYearTypical(Number(feesTpAgeMin))
            }
            return
        }
    }

    return (
        <>
            {iulFeesbtnToggled ? (
                <IULFeesChart chartData={finalData?.feesGraphDetails} />
            ) : (
                <Grid container className={flagShowCalculationErrorTp ? styles.accValueErrorStyleWrapper : styles.accValueTabWrapper}>
                    {/* TYPICAL PLAN */}
                    <Grid item xs={12} sm={12} md={11} lg={6} xl={6} sx={{ borderRight: "1px solid #E2E8F0" }}>
                        <Grid container>
                            <Grid item xs={12} className={styles.headerContainer}>
                                <Grid container justifyContent={"space-between"} alignItems={"center"}>
                                    <Grid item>
                                        <Grid container>
                                            <Grid item xs={12} className={styles.typicalPlanTxt}>
                                                Typical Plan
                                            </Grid>
                                            <Grid item xs={12} className={styles.typicalPlanSubTxt}>
                                                Traditional Plan
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                    <Grid item>
                                        <Grid container gap={"10px"} alignItems={"center"}>
                                            <Grid item>
                                                <span className={styles.headerIdentifier}>BASELINE</span>
                                            </Grid>
                                            <Grid item>
                                                <CustomNumberTextField
                                                    type="number"
                                                    size="small"
                                                    variant="outlined"
                                                    value={changeYearTypical}
                                                    onChange={(e) => {
                                                        setChangeYearTypical(e?.target?.value);
                                                    }}
                                                    InputProps={{ inputProps: { min: feesTpAgeMin, max: feesTpAgeMax } }}
                                                    onBlur={inputBlureChangeYear}
                                                    onKeyUp={(e) => {
                                                        if (e.keyCode === 40 || e.keyCode === 38 || e.keyCode == 13)
                                                            inputChangeYear(e);
                                                    }}
                                                    customStyles={{
                                                        backgroundColor: "white",
                                                        color: "black"
                                                    }}
                                                />
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </Grid>
                            <Grid item xs={12} className={styles.fieldContainer}>
                                <Grid container gap={"10px"}>
                                    <Grid item xs={12}>
                                        <Grid container>
                                            <Grid item className={styles.outputLabel} xs={10}>Current Age</Grid>
                                            <Grid item className={styles.outputValue} xs={2}>{finalData?.current_age || "0"}</Grid>
                                        </Grid>
                                    </Grid>
                                    <Grid item xs={12}>
                                        <Grid container>
                                            <Grid item xs={10} className={styles.outputLabel}>Age at Retirement</Grid>
                                            <Grid item xs={2} className={styles.outputValue}>{finalData?.ageAtRetirement || "0"}</Grid>
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </Grid>
                            <Grid item xs={12} className={`${styles.greyContainer} ${styles.accountSetupSectionForFees}`}>
                                <Grid container gap={"10px"}>
                                    <Grid item xs={12} className={styles.sectionTitle}>
                                        Account Setup
                                    </Grid>
                                    <Grid item xs={12}>
                                        <Grid container>
                                            <Grid item xs={10} className={styles.outputLabel}>Annual Contribution</Grid>
                                            <Grid item xs={2} className={styles.outputValue}>
                                                {formatNumber(finalData?.typical_plan?.yearly_contribution[changeYearTypical]) || "$0"}
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                    <Grid item xs={12}>
                                        <Grid container>
                                            <Grid item xs={10} className={styles.outputLabel}>Starting Account Balance</Grid>
                                            <Grid item xs={2} className={styles.outputValue}>
                                                {formatNumber(finalData?.typical_plan?.currAccountBalance) || "$0"}
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                    <Grid item xs={12}>
                                        <Grid container>
                                            <Grid item xs={10} className={styles.outputLabel}>Account Balance with Contributions</Grid>
                                            <Grid item xs={2} className={styles.outputValue}>
                                                {formatNumber(finalData?.typical_plan?.FEES_age_data[changeYearTypical]?.balance) || "$0"}
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </Grid>
                            <Grid item xs={12} className={styles.fieldContainer}>
                                <Grid container gap={"10px"}>
                                    <Grid item xs={12} className={styles.sectionTitle}>
                                        Returns & Fees
                                    </Grid>
                                    <Grid item xs={12}>
                                        <Grid container>
                                            <Grid item xs={10} className={styles.outputLabel}>Annual Rate of Return</Grid>
                                            <Grid item xs={2} className={styles.outputValue}>{finalData?.typical_plan?.rateOfReturnWorking || 0}%</Grid>
                                        </Grid>
                                    </Grid>
                                    <Grid item xs={12}>
                                        <Grid container>
                                            <Grid item xs={10} className={styles.outputLabel}>Fees</Grid>
                                            <Grid item xs={2} className={styles.typicalFeesValue}>
                                                {finalData?.typical_plan?.percentFees || 0}% <span className={styles.typicalFeesText}>Annual</span>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </Grid>
                            <Grid item xs={12} className={`${styles.lightblueContainer} ${styles.totalFeesSection}`}>
                                <Grid container gap={"10px"}>
                                    <Grid item xs={12}>
                                        <Grid container alignItems="center" gap="10px">
                                            <Grid item>
                                                <span style={{ display: "inline-block", width: "4px", height: "18px", backgroundColor: "#3B78CE", borderRadius: "2px" }} />
                                            </Grid>
                                            <Grid item>
                                                <Typography component={"span"} className={styles.sectionTitle}>
                                                    Fees - No Life Insurance
                                                </Typography>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                    <Grid item xs={12} className={styles.totalValueContainer}>
                                        <Grid container>
                                            <Grid item xs={10} className={styles.outputLabel}>Annual Fees</Grid>
                                            <Grid item xs={2} className={styles.outputValue}>
                                                {formatNumber(finalData?.typical_plan?.FEES_age_data[changeYearTypical]?.annual_fees) || "$0"}
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                    <Grid item xs={12} className={styles.totalValueContainer}>
                                        <Grid container>
                                            <Grid item xs={10} className={styles.outputLabel}>Total Fees Paid</Grid>
                                            <Grid item xs={2} className={styles.outputValue}>
                                                {formatNumber(finalData?.typical_plan?.FEES_age_data[changeYearTypical]?.total_fees_paid) || "$0"}
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                    {flagShowCalculationErrorTp &&
                                        <Grid item xs={12} className={styles.typicalValueEmptyTxt}>
                                            Typical plan account value is empty
                                        </Grid>
                                    }
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                    {/* IUL PLAN */}
                    <Grid item xs={12} sm={12} md={12} lg={6} xl={6}>
                        <Grid container>
                            <Grid item xs={12} className={styles.headerContainer}>
                                <Grid container justifyContent={"space-between"} alignItems={"center"}>
                                    <Grid item>
                                        <Grid container>
                                            <Grid item xs={12} className={styles.typicalPlanTxt}>
                                                IUL Strategy
                                            </Grid>
                                            <Grid item xs={12} className={styles.typicalPlanSubTxt}>
                                                Alternative Plan
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                    <Grid item>
                                        <Grid container gap={"10px"} alignItems={"center"}>
                                            <Grid item>
                                                <span className={styles.headerIdentifier}>COMPARISON</span>
                                            </Grid>
                                            <Grid item>
                                                <CustomNumberTextField
                                                    type="number"
                                                    size="small"
                                                    variant="outlined"
                                                    value={changeYearIUL}
                                                    onChange={(e) => {
                                                        setChangeYearIUL(e?.target?.value);
                                                    }}
                                                    InputProps={{ inputProps: { min: feesIulAgeMin, max: feesIulAgeMax } }}
                                                    onBlur={InputBlurChangeIUL}
                                                    onKeyUp={(e) => {
                                                        if (e.keyCode === 40 || e.keyCode === 38 || e.keyCode == 13)
                                                            InputChangeYearIUL(e);
                                                    }}
                                                    customStyles={{
                                                        backgroundColor: "white",
                                                        color: "black"
                                                    }}
                                                />
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </Grid>
                            <Grid item xs={12} className={styles.fieldContainer}>
                                <Grid container gap={"10px"}>
                                    <Grid item xs={12}>
                                        <Grid container>
                                            <Grid item className={styles.outputLabel} xs={10}>Current Age</Grid>
                                            <Grid item className={styles.outputValue} xs={2}>{finalData?.current_age || "0"}</Grid>
                                        </Grid>
                                    </Grid>
                                    <Grid item xs={12}>
                                        <Grid container>
                                            <Grid item xs={10} className={styles.outputLabel}>Age at Retirement</Grid>
                                            <Grid item xs={2} className={styles.outputValue}>{finalData?.ageAtRetirement || "0"}</Grid>
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </Grid>
                            <Grid item xs={12} className={`${styles.greyContainer} ${styles.accountSetupSectionForFees}`}>
                                <Grid container gap={"10px"}>
                                    <Grid item xs={12} className={styles.sectionTitle}>
                                        Account Setup
                                    </Grid>
                                    <Grid item xs={12}>
                                        <Grid container>
                                            <Grid item xs={10} className={styles.outputLabel}>Annual Premium</Grid>
                                            <Grid item xs={2} className={styles.outputValue}>
                                                {formatNumber(finalData?.iul_plan?.yearly_premium[changeYearIUL]) || "$0"}
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                    <Grid item xs={12}>
                                        <Grid container>
                                            <Grid item xs={10} className={styles.outputLabel}>Lump Sum Premium</Grid>
                                            <Grid item xs={2} className={styles.outputValue}>
                                                {formatNumber(finalData?.iul_plan?.lumpSumPremium) || "$0"}
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </Grid>
                            <Grid item xs={12} className={styles.fieldContainer}>
                                <Grid container gap={"10px"}>
                                    <Grid item xs={12} className={styles.sectionTitle}>
                                        Returns & Fees
                                    </Grid>
                                    <Grid item xs={12}>
                                        <Grid container>
                                            <Grid item xs={10} className={styles.outputLabel}>Annual Rate of Return</Grid>
                                            <Grid item xs={2} className={styles.outputValue}>{finalData?.iul_plan?.rateOfReturn || 0}%</Grid>
                                        </Grid>
                                    </Grid>
                                    <Grid item xs={12}>
                                        <Grid container>
                                            <Grid item xs={9} className={styles.outputLabel}>Fees</Grid>
                                            <Grid item xs={3} className={styles.iulFeesValue}>
                                                Included <span className={styles.iulFeesText}>No Extra</span>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </Grid>
                            <Grid item xs={12} className={`${styles.lightblueContainer} ${styles.totalFeesSection}`}>
                                <Grid container gap={"10px"}>
                                    <Grid item xs={12}>
                                        <Grid container alignItems="center" gap="10px">
                                            <Grid item>
                                                <span style={{ display: "inline-block", width: "4px", height: "18px", backgroundColor: "#3B78CE", borderRadius: "2px" }} />
                                            </Grid>
                                            <Grid item>
                                                <Typography component={"span"} className={styles.sectionTitle}>
                                                    Fees - Includes Life Insurance
                                                </Typography>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                    <Grid item xs={12} className={styles.totalValueContainer}>
                                        <Grid container>
                                            <Grid item xs={10} className={styles.outputLabel}>Annual Fees</Grid>
                                            <Grid item xs={2} className={styles.outputValue}>
                                                {formatNumber(finalData?.iul_plan?.FEES_age_data[changeYearIUL]?.annual_fees) || "$0"}
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                    <Grid item xs={12} className={styles.totalValueContainer}>
                                        <Grid container>
                                            <Grid item xs={10} className={styles.outputLabel}>Total Fees Paid</Grid>
                                            <Grid item xs={2} className={styles.outputValue}>
                                                {formatNumber(finalData?.iul_plan?.FEES_age_data[changeYearIUL]?.total_fees_paid) || "$0"}
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                    <Grid item xs={12} className={styles.totalValueContainer}>
                                        <Grid container>
                                            <Grid item xs={10} className={styles.outputLabel}>Total Death Benefits</Grid>
                                            <Grid item xs={2} className={styles.outputValue}>
                                                {formatNumber(finalData?.iul_plan?.FEES_age_data[changeYearIUL]?.total_death_benefit) || "$0"}
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
            )}
        </>
    )
}

export default FeesTab
